import classNames from "classnames";
import * as React from 'react';
import {
  DISABLE_NOTIFICATIONS_FILTER_TOP_ID,
  navigateDisableNotifications,
  stringifyDisableNotificationsFilter,
} from "src/disableNotifications/src/helpers/disableNotificationsFilter";
import Input from "src/components/Form/components/Input";
import style from './Filter.scss';
import Button from "src/components/Button";
import Icon from "src/components/Icon";
import { currentOffset } from "src/helpers/browserHacks";

type Props = {
  search: string,
};

const Filter: React.FunctionComponent<Props> = (props) => {
  const { search } = props;
  const topRef = React.useRef<HTMLDivElement>();
  const containerRef = React.useRef<HTMLDivElement>();
  const searchRef = React.useRef<HTMLInputElement>();
  const [active, setActive] = React.useState(false);

  React.useEffect(() => {
    searchRef.current.value = search || '';
  }, [search])

  React.useEffect(() => {
    let containerTop: number;
    let _active = false;

    const updateContainerTop = () => {
      const top = topRef.current;
      if (top) containerTop = top.offsetTop
    }
    window.addEventListener('resize', updateContainerTop);
    updateContainerTop();

    const onScroll = () => {
      const currentActive = currentOffset() > containerTop;
      if ((currentActive && !_active) || (!currentActive && _active)) {
        setActive(currentActive);
        _active = currentActive;
      }
    }
    window.addEventListener('scroll', onScroll);
    onScroll();
    return () => {
      window.removeEventListener('resize', updateContainerTop);
      window.removeEventListener('scroll', onScroll);
    }
  }, []);

  return (
    <>
      <div id={DISABLE_NOTIFICATIONS_FILTER_TOP_ID} ref={topRef} />
      <div ref={containerRef} className={classNames(style.container, active && style.containerActive)}>
        <form
          className={style.form}
          onSubmit={React.useCallback((e) => {
            e.preventDefault();
            navigateDisableNotifications(stringifyDisableNotificationsFilter({ search: searchRef.current.value || undefined }));
          }, [])}
        >
          <label className={style.search}>
            <Input label="Поиск по номеру помещения" ref={searchRef} className={!!search && style.inputActive} />

            {!!search && (
              <button
                type="button"
                className={style.clear}
                onClick={() => {
                  navigateDisableNotifications(stringifyDisableNotificationsFilter({ search: undefined }));
                }}
              >
                <Icon icon={require('@icon/x16/x.svg')} />
              </button>
            )}
          </label>
          <Button icon={require("@icon/x16/search.svg")} />
        </form>
      </div>
    </>
  );
};

export default React.memo(Filter);